import React from "react";
import { Helmet } from "react-helmet";
import { Translation } from "react-i18next";
import styles from './termOfUser.module.scss';

export default class TermOfUser extends React.Component {

  render() {
    return (
      <Translation ns={['translation', 'termOfUser']}>
        {t => (
          <>
            <Helmet>
              <title>{t("termOfUser:Terms and Conditions")}</title>
            </Helmet>

            <div className={styles.termofuser}>
              <div className="container">
              <div className="row">
                  <div className="col-12 text-center">
                    <h3>{t("termOfUser:Terms and Conditions")}</h3>
                    
                  </div>
                  <div>
                    <p dangerouslySetInnerHTML={{ __html: t("termOfUser:The terms and conditions herein") }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t("termOfUser:Please read") }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t("termOfUser:This Agreement") }}></p>

                    <ol>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses1')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses2')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses3')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses4')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses5')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses6')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses7')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses8')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses9')}</li>
                         <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses10')} </li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses11')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses12')}<br/>
                            {t('termOfUser:pdpaTermofUses12-A')}<br/>
                            {t('termOfUser:pdpaTermofUses12-B')}<br/>
                            {t('termOfUser:pdpaTermofUses12-C')}<br/>
                            {t('termOfUser:pdpaTermofUses12-1')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses13')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses14')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses15')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses16')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses17')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses18')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses19')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses20')} <u>{t('termOfUser:pdpaTermofUses20-A')}</u></li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses21')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses22')}</li>
                        <li className="li-term-of-user">{t('termOfUser:pdpaTermofUses23')}</li>
                    </ol> 

                    <span><i>{t('termOfUser:last update')}</i></span>
                  </div>
                </div>
              </div>


            </div>
          </>
        )}
      </Translation>
    )
  }

}
